export default "__VITE_ASSET__cd5710ae__"